import * as fromFeature from '../reducers';
import { createSelector } from '@ngrx/store';

export const getSidebar = createSelector(fromFeature.featureSelector, (state: fromFeature.FeatureState) => state.sidebar);
export const getSidebarItems = createSelector(getSidebar, (state) => state.items);
